/**
 * 会员专区路由配置
 */
import { PAGE_LEVEL } from '@/constants';

export default {
  meta: {
    localeModules: ['member', 'report', 'research', 'question', 'aiChat', 'cloudDocument', 'summary', 'roadshow']
  },
  path: '/memberZone',
  redirect: '/memberZone/index',
  component: () => import(/* webpackChunkName: 'router-view' */ '@/router/routers/routerView.vue'),
  children: [
    {
      path: 'index',
      name: 'memberZone',
      component: () => import(/* webpackChunkName: 'member-zone' */ '@/pages/memberZone/index.vue'),
      meta: {
        name: 'routers.member_zone',
        pageLevel: PAGE_LEVEL.FIRST,
        componentName: 'MemberZone',
        keepAlive: true,
        requireAuth: false, // 不需要权限，所有登录用户都可以访问
        hideSecondMenu: true, // 隐藏二级导航菜单
        noContentPadding: true // 设计稿页面铺满公共内容容器，不使用默认 12px 内距
      }
    }
  ]
};
